import endsWith from "lodash/endsWith";

const appcraftImages = "https://app.appcraft.events/images";
const objectStorage = "https://storage.gra.cloud.ovh.net/v1/AUTH_1aa44ccb48c74c7f956a0ce09a3527ea/static001/events";

function shorthand(url) {
  if (url.indexOf(appcraftImages) === 0) {
    let shortUrl = url;
    if ((endsWith(shortUrl, ".jpg") || endsWith(shortUrl, ".jpeg")) && shortUrl.indexOf("-original") === -1) {
      // Inject -original
      shortUrl = shortUrl.replace(".jpg", "-original.jpg").replace(".jpeg", "-original.jpeg");
    }
    return shortUrl.replace(appcraftImages, "_appcraft_images_");
  }
  if (url.indexOf(objectStorage) === 0) {
    return url.replace(objectStorage, "evt");
  }
  return url;
}

function cdn(uri) {
  const url = uri && (typeof uri === "string" ? uri : uri.uri);

  // Only use CDN for appcraft event images
  if (url && (url.indexOf("appcraft.events") !== -1 || url.indexOf(objectStorage) !== -1)) {
    return `https://avfuefcxen.cloudimg.io/cdn/n/n/${shorthand(url)}`;
  }
  return url;
}

function maxWidth(image, maxWidth = 1200) {
  const url = image && (typeof image === "string" ? image : image.uri);

  // Only use CDN for appcraft event images
  if (url && (url.indexOf("appcraft.events") !== -1 || url.indexOf(objectStorage) !== -1)) {
    return `https://avfuefcxen.cloudimg.io/v7/${shorthand(
      url
    )}?w=${maxWidth}&func=bound&org_if_sml=1&force_format=original`;
  }
  return url;
}

function square(uri, size = 200) {
  const url = uri && (typeof uri === "string" ? uri : uri.uri);

  // Only use CDN for appcraft event images
  if (url && (url.indexOf("appcraft.events") !== -1 || url.indexOf(objectStorage) !== -1)) {
    return `https://avfuefcxen.cloudimg.io/v7/${shorthand(url)}?w=${size}&h=${size}&force_format=original`;
  }
  return url;
}

export default {
  shorthand,
  cdn,
  maxWidth,
  square,
};
